export const DEFAULT_ENTITY = 'default'
